import type { FC } from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import SeguimientoOficinaPie from './SeguimientoOficinaPie';
import SeguimientoOficinaDetail from './SeguimientoOficinaDetail';
import SeguimientoOficinaConvenio from './SeguimientoOficinaConvenio';
import { onGet } from '../../../store/actions/global';

const SeguimientoOficina: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const title = 'Seguimiento de Convenios - Oficina';
  const defaultLimit = 10;
  const [dataPie, setDataPie] = useState([]);
  const [detail, setDetail] = useState({
    data: [],
    resume: { operaciones: 0, facturacion: 0, meta: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [convenio, setConvenio] = useState({
    data: [],
    resume: { operaciones: 0, facturacion: 0, meta: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [valuesFilter, setValuesFilter] = useState({ year: null, month: null });

  const handleChangePage = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento-oficina/detail',
      body: {
        year,
        month,
        limit: Number(detail.pages.limit),
        page,
        type: 'JFN',
      },
    });
    setDetail(response);
  };

  const handleChangeRowsPerPage = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento-oficina/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFN',
      },
    });
    setDetail(response);
  };

  const handleChangePageConvenio = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento-oficina/detail',
      body: {
        year,
        month,
        limit: Number(convenio.pages.limit),
        page,
        type: 'CONVENIO',
      },
    });
    setConvenio(response);
  };

  const handleChangeRowsPerPageConvenio = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento-oficina/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'CONVENIO',
      },
    });
    setConvenio(response);
  };

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setValuesFilter(values);
      const response = await onGetExec({
        url: '/dashboard/seguimiento-oficina',
        body: { ...values, limit: defaultLimit },
      });
      setDataPie(response?.dataPie);
      setDetail(response?.factTeam);
      setConvenio(response?.convenio);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} yearMonth />
        <Grid container spacing={2} mt={1} justifyContent="center">
          <Grid item md={5} xs={12}>
            <SeguimientoOficinaPie dataPie={dataPie} />
          </Grid>
          <Grid item md={7} xs={12}>
            <SeguimientoOficinaDetail
              content={detail}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              level={1}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <SeguimientoOficinaConvenio
              content={convenio}
              handleChangePage={handleChangePageConvenio}
              handleChangeRowsPerPage={handleChangeRowsPerPageConvenio}
            />
          </Grid>
        </Grid>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(SeguimientoOficina);
